<template>
  <div class="container-fluid principal">
    <div class="row">
      <div class="col-md-12">
        <Toast position="top-right" :baseZIndex="2222" />
        <Toolbar class="p-mb-4">
          <template #left>
            <div class="row">
              <div class="col-md-12">
                <Button
                  label="Add"
                  icon="pi pi-plus"
                  class="p-button-success p-mr-2"
                  @click="openNew"
                />
              </div>
            </div>
          </template>          
          <template #right>
            <div class="row">
              <div class="col-md-12">
                <Button
                  v-if="excel_loaded"
                  label="Excel"
                  icon="pi pi-save"
                  class="p-button-info p-mr-2"
                  @click="generateExcel"
                />
                <ProgressSpinner
                  v-else
                  style="width: 50px; height: 50px"
                  strokeWidth="8"
                  fill="#EEEEEE"
                  animationDuration=".5s"
                />
              </div>
            </div>
          </template>
        </Toolbar>
        <DataTable
          :value="expats"
          :loading="expats_data_table_loading"
          class="p-datatable-striped p-datatable-sm"
          dataKey="expat_id"
          :scrollable="true"
          :paginator="true"
          :rows="25"
          :filters="filters"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[25, 50, 75, 150, 300]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} expats"
          editMode="row"
          :editingRows.sync="editingExpatRows"
          @row-edit-init="onRowEditExpatInit"
          @row-edit-cancel="onRowEditExpatCancel"
          @row-edit-save="onRowEditExpatSave"
        >
          <template #header>
            <div class="table-header-container">
              <h5 class="p-m-0">Expats</h5>
              <div class="row">
                <div class="col-md-2">
                  <span class="p-input-icon-left input-full-width">
                    <i class="pi pi-search" />
                    <InputText
                      v-model="filters['global']"
                      placeholder="Search..."
                      class="input-search-width"
                    />
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-for="col of selected_columns">
            <Column
              v-if="col.field == 'expat_id'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 175px"
              bodyStyle="text-align: center;width: 175px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.expat_id == ''"
                  class="p-sortable-column"
                  @click="
                    sortExpatDataTable(
                      'expat_id',
                      'expat_id',
                      sorted_by.expat_id
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.expat_id == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_id',
                      'expat_id',
                      sorted_by.expat_id
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.expat_id == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_id',
                      'expat_id',
                      sorted_by.expat_id
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'expat_name'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 175px"
              bodyStyle="text-align: center;width: 175px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.expat_name == ''"
                  class="p-sortable-column"
                  @click="
                    sortExpatDataTable(
                      'expat_name',
                      'expat_name',
                      sorted_by.expat_name
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.expat_name == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_name',
                      'expat_name',
                      sorted_by.expat_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.expat_name == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_name',
                      'expat_name',
                      sorted_by.expat_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'expat_direction'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 175px"
              bodyStyle="text-align: center;width: 175px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.expat_direction == ''"
                  class="p-sortable-column"
                  @click="
                    sortExpatDataTable(
                      'expat_direction',
                      'expat_direction',
                      sorted_by.expat_direction
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.expat_direction == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_direction',
                      'expat_direction',
                      sorted_by.expat_direction
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.expat_direction == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_direction',
                      'expat_direction',
                      sorted_by.expat_direction
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'expat_destination'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 175px"
              bodyStyle="text-align: center;width: 175px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.expat_destination == ''"
                  class="p-sortable-column"
                  @click="
                    sortExpatDataTable(
                      'expat_destination',
                      'expat_destination',
                      sorted_by.expat_destination
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.expat_destination == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_destination',
                      'expat_destination',
                      sorted_by.expat_destination
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.expat_destination == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_destination',
                      'expat_destination',
                      sorted_by.expat_destination
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'expat_notify_email'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 220px"
              bodyStyle="text-align: center;width: 220px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.expat_notify_email == ''"
                  class="p-sortable-column"
                  @click="
                    sortExpatDataTable(
                      'expat_notify_email',
                      'expat_notify_email',
                      sorted_by.expat_notify_email
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.expat_notify_email == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_notify_email',
                      'expat_notify_email',
                      sorted_by.expat_notify_email
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.expat_notify_email == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_notify_email',
                      'expat_notify_email',
                      sorted_by.expat_notify_email
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'expat_copy_email'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 220px"
              bodyStyle="text-align: center;width: 220px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.expat_copy_email == ''"
                  class="p-sortable-column"
                  @click="
                    sortExpatDataTable(
                      'expat_copy_email',
                      'expat_copy_email',
                      sorted_by.expat_copy_email
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.expat_copy_email == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_copy_email',
                      'expat_copy_email',
                      sorted_by.expat_copy_email
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.expat_copy_email == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_copy_email',
                      'expat_copy_email',
                      sorted_by.expat_copy_email
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'expat_rut'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 175px"
              bodyStyle="text-align: center;width: 175px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.expat_rut == ''"
                  class="p-sortable-column"
                  @click="
                    sortExpatDataTable(
                      'expat_rut',
                      'expat_rut',
                      sorted_by.expat_rut
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.expat_rut == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_rut',
                      'expat_rut',
                      sorted_by.expat_rut
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.expat_rut == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'expat_rut',
                      'expat_rut',
                      sorted_by.expat_rut
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'shipper_id'"
              :field="'shipper_details.shipper_name'"
              :key="col.field"
              headerStyle="text-align: center;width: 175px"
              bodyStyle="text-align: center;width: 175px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.shipper_details_shipper_name == ''"
                  class="p-sortable-column"
                  @click="
                    sortExpatDataTable(
                      'shipper_details.shipper_name',
                      'shipper_details_shipper_name',
                      sorted_by.shipper_details_shipper_name
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.shipper_details_shipper_name == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'shipper_details.shipper_name',
                      'shipper_details_shipper_name',
                      sorted_by.shipper_details_shipper_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.shipper_details_shipper_name == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'shipper_details.shipper_name',
                      'shipper_details_shipper_name',
                      sorted_by.shipper_details_shipper_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <Dropdown
                  v-model="slotProps.data['shipper_id']"
                  class="input-full-width"
                  :options="shippers"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Choose a shipper"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>
              </template>
            </Column>

            <Column
              v-else-if="col.field == 'company_id'"
              :field="'company_details.company_name'"
              :key="col.field"
              headerStyle="text-align: center;width: 225px"
              bodyStyle="text-align: center;width: 225px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.company_details_company_name == ''"
                  class="p-sortable-column"
                  @click="
                    sortExpatDataTable(
                      'company_details.company_name',
                      'company_details_company_name',
                      sorted_by.company_details_company_name
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.company_details_company_name == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'company_details.company_name',
                      'company_details_company_name',
                      sorted_by.company_details_company_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.company_details_company_name == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortExpatDataTable(
                      'company_details.company_name',
                      'company_details_company_name',
                      sorted_by.company_details_company_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.company_details.company_name }}
                </span>
              </template>
              <template #editor="slotProps">
                <Dropdown
                  v-model="slotProps.data['company_id']"
                  class="input-full-width"
                  :options="companies"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Choose a company"
                  :filter="true"
                  emptyFilterMessage="No results found"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'actions' && can_show_actions"
              headerStyle="text-align: center;width: 7rem"
              bodyStyle="text-align: center;width: 7rem; text-align: center;"
              :key="col.field"
            >
              <template #body="slotProps">
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger button-margin-right"
                  @click="confirmDeleteExpat(slotProps.data)"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'editExpat'"
              :rowEditor="true"
              headerStyle="text-align: center;width: 7rem"
              bodyStyle="text-align: center;width: 7rem; text-align:center;"
              :key="col.field"
            >
            </Column>
          </template>
        </DataTable>
        <Dialog
          :baseZIndex="2222"
          :visible.sync="createExpatDialog"
          :style="{ width: '475px' }"
          header="Nuevo Expatriado"
          :modal="true"
          :maximizable="true"
          position="center"
          class="p-fluid"
        >
          <div class="p-field">
            <label for="expat_rut">Rut</label>
            <br />
            <InputText
              id="expat_rut"
              v-model="newExpat.expat_rut"
              class="input-full-width"
              required="true"
              placeholder="Ex. 12345678-9"
              :class="{
                'p-invalid': newExpatSubmitted && invalid.expat_rut,
              }"
            />
            <small
              class="p-invalid"
              v-if="newExpatSubmitted && invalid.expat_rut"
              >Please complete this field.</small
            ><br /><br />
          </div>
          <div class="p-field">
            <label for="expat_name">Full Name</label>
            <br />
            <InputText
              id="expat_name"
              v-model="newExpat.expat_name"
              class="input-full-width"
              required="true"
              placeholder="Ex. Juan Perez"
              :class="{
                'p-invalid': newExpatSubmitted && invalid.expat_name,
              }"
            />
            <small
              class="p-invalid"
              v-if="newExpatSubmitted && invalid.expat_name"
              >Please complete this field.</small
            ><br /><br />
          </div>
          <div class="p-field">
            <label for="expat_direction">Direction</label>
            <br />
            <InputText
              id="expat_direction"
              v-model="newExpat.expat_direction"
              class="input-full-width"
              required="true"
              placeholder="Ex. Av. Isabel Riquelme #123"
              :class="{
                'p-invalid': newExpatSubmitted && invalid.expat_direction,
              }"
            />
            <small
              class="p-invalid"
              v-if="newExpatSubmitted && invalid.expat_direction"
              >Please complete this field.</small
            ><br /><br />
          </div>

          <div class="p-field">
            <label for="expat_destination">Destination</label>
            <br />
            <InputText
              id="expat_destination"
              v-model="newExpat.expat_destination"
              class="input-full-width"
              required="true"
              placeholder="Ex. Santiago"
              :class="{
                'p-invalid': newExpatSubmitted && invalid.expat_destination,
              }"
            />
            <small
              class="p-invalid"
              v-if="newExpatSubmitted && invalid.expat_destination"
              >Please complete this field.</small
            ><br /><br />
          </div>
          <div class="p-field">
            <label for="shipper_id">Shipper</label>
            <br />

            <Dropdown
              id="shipper_id"
              v-model="newExpat.shipper_id"
              class="input-full-width"
              :options="shippers"
              optionLabel="label"
              optionValue="value"
              placeholder="Choose a shipper"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.label }}</span>
              </template>
            </Dropdown>
            <small
              class="p-invalid"
              v-if="newExpatSubmitted && invalid.shipper_id"
              >Please complete this field.
            </small>
            <br />
          </div>

          <div class="p-field">
            <label for="company_id">Company</label>
            <br />
            <Dropdown
              id="company_id"
              v-model="newExpat.company_id"
              class="input-full-width"
              :options="companies"
              optionLabel="label"
              optionValue="value"
              :filter="true"
              emptyFilterMessage="No results found"
              placeholder="Choose a company"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.label }}</span>
              </template>
            </Dropdown>
            <small
              class="p-invalid"
              v-if="newExpatSubmitted && invalid.company_id"
              >Please complete this field. </small
            ><br />
          </div>
          <template #footer>
            <Button
              v-if="!load_creation"
              label="Cancel"
              icon="pi pi-times"
              class="p-button-text"
              @click="hideDialog"
            />
            <Button
              v-if="!load_creation"
              label="Save"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveNewExpat"
            />
            <ProgressSpinner
              v-else
              style="text-align: center;width: 50px; height: 50px"
              strokeWidth="8"
              fill="#EEEEEE"
              animationDuration=".5s"
            /> </template
        ></Dialog>

        <Dialog
          :baseZIndex="2222"
          :visible.sync="deleteExpatDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="expat">
              Are you sure you want to delete this data?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteExpatDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedExpat"
            /> </template
        ></Dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Toast from "primevue/toast";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import RadioButton from "primevue/radiobutton";
import InputNumber from "primevue/inputnumber";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Textarea from "primevue/textarea";
import Avatar from "primevue/avatar";
import Tag from "primevue/tag";
import Vue from "vue";
import Dropdown from "primevue/dropdown";
import ProgressSpinner from "primevue/progressspinner";
import Calendar from "primevue/calendar";
import InputSwitch from "primevue/inputswitch";
import Checkbox from "primevue/checkbox";
export default {
  name: "login-page",
  bodyClass: "login-page",

  data() {
    return {
      excel_loaded: true,
      expats: [],
      createExpatDialog: false,
      deleteExpatDialog: false,
      expat: {},
      newExpat: {
        expat_id: "",
        expat_name: "",
        expat_rut: "",
        expat_direction: "",
        expat_destination: "",
        shipper_id: "",
        company_id: "",
        expat_copy_email: "",
        expat_notify_email: "",
      },
      filters: {},
      newExpatSubmitted: false,
      columns: [],
      selected_columns: [],
      sorted_by: {
        shipper_details_shipper_name: "",
        expat_id: "",
        company_details_company_name: "",
        expat_name: "",
        expat_rut: "",
        expat_direction: "",
        expat_destination: "",
        expat_notify_email: "",
        expat_copy_email: "",
      },
      expats_data_table_loading: true,
      editingExpatRows: [],
      editingImportRows: [],
      editingAfterSalesRows: [],
      shippers: [],
      companies: [],
      selected_shipper_id: "",
      selected_company_id: "",
      expat_loaded: false,
      can_show_actions: false,
      invalid: {
        expat_rut: false,
        expat_name: false,
        shipper_id: false,
        company_id: false,
        expat_direction: false,
        expat_destination: false,
      },
      load_creation: false,
    };
  },
  created() {
    this.columns = [
      { field: "expat_id", header: "EXPAT ID" },
      { field: "expat_name", header: "NAME" },
      { field: "expat_rut", header: "RUT" },
      { field: "expat_direction", header: "ADDRESS" },
      { field: "expat_destination", header: "DESTINY" },
      { field: "expat_notify_email", header: "NOTIFY" },
      { field: "expat_copy_email", header: "COPY" },
      { field: "shipper_id", header: "SHIPPER" },
      { field: "company_id", header: "COMPANY" },
      { field: "actions", header: "Acciones" },
      { field: "editExpat", header: "Edit" },
    ];
    this.selected_columns = this.columns;
    this.originalRows = {};
  },
  mounted() {
    this.getExpats();
    this.getShippers();
    this.getCompanies();
  },
  methods: {    
    generateExcel() {
      let token = this.getToken();
      this.excel_loaded = false;
      this.axios
        .post(
          `${process.env.VUE_APP_EXPATS}/excel`,
          { expats: this.expats },
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          this.$toast.add({
            severity: "success",
            summary: "Exported Data",
            detail: "The data has been successfully exported.",
            life: 5000,
          });
          Object.assign(document.createElement("a"), {
            target: "_blank",
            href: res.data.path,
          }).click();
        })
        .catch((error) => {
          // console.log(error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while generating the excel, try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.excel_loaded = true;
        });
    },
    getShippers() {
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_SHIPPERS}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          let result_shippers = res.data;
          this.shippers = [];
          result_shippers.forEach((element) => {
            this.shippers.push({
              label: element.shipper_name,
              value: element.shipper_id,
            });
          });
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {});
    },
    getCompanies() {
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_COMPANIES}?company_is_master=false`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          let result_companies = res.data;
          this.companies = [];
          result_companies.forEach((element) => {
            this.companies.push({
              label: element.company_name,
              value: element.company_id,
            });
          });
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          if (this.expats.length > 0) {
            this.expats_data_table_loading = false;
          }
        });
    },
    getExpats() {
      this.expats_data_table_loading = true;
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_EXPATS}?depth=true`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.expats = res.data;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.can_show_actions = true;
          if (this.expats.length > 0) {
            this.expats_data_table_loading = false;
          }
        });
    },
    setsortExpatDataTable(sort_data, sort_value) {
      Object.keys(this.sorted_by).forEach((key) => {
        if (key == sort_data) {
          this.sorted_by[key] = sort_value;
          let is_asc = sort_value == "DESC" ? true : false;
          if (this.sorted_by[key] != "") {
            this.sortExpats(key, is_asc);
          } else {
            this.getExpats();
          }
        } else {
          this.sorted_by[key] = "";
        }
      });
    },
    sortExpats(sort_by, is_asc) {
      this.expats_data_table_loading = true;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_EXPATS}?sort=${sort_by}&asc=${is_asc}&depth=true`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);
          this.expats = res.data;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          if (this.expats.length > 0) {
            this.expats_data_table_loading = false;
          }
        });
    },
    sortExpatDataTable(sort_by, sort_data, sort_value) {
      // console.log(sort_by, sort_data, sort_value);
      if (sort_value == "") {
        sort_value = "ASC";
        this.setsortExpatDataTable(sort_data, sort_value);
      } else if (sort_value == "ASC") {
        sort_value = "DESC";
        this.setsortExpatDataTable(sort_data, sort_value);
      } else if (sort_value == "DESC") {
        sort_value = "";
        this.setsortExpatDataTable(sort_data, sort_value);
      }
    },
    getToken() {
      let token = localStorage.getItem("idToken");
      return token;
    },
    openNew() {
      this.newExpat = {
        expat_id: "",
        expat_name: "",
        expat_rut: "",
        expat_direction: "",
        expat_destination: "",
        shipper_id: "",
        company_id: "",
        expat_copy_email: "",
        expat_notify_email: "",
      };
      this.newExpatSubmitted = false;
      this.createExpatDialog = true;
    },
    hideDialog() {
      this.createExpatDialog = false;
      this.newExpatSubmitted = false;
      this.newExpat = {
        expat_id: "",
        expat_name: "",
        expat_rut: "",
        expat_direction: "",
        expat_destination: "",
        shipper_id: "",
        company_id: "",
        expat_copy_email: "",
        expat_notify_email: "",
      };
    },
    saveNewExpat() {
      this.newExpatSubmitted = true;
      this.invalid.expat_name =
        this.newExpat.expat_name.trim().length == 0 ? true : false;
      this.invalid.shipper_id =
        this.newExpat.shipper_id.trim().length == 0 ? true : false;
      this.invalid.company_id =
        this.newExpat.company_id.trim().length == 0 ? true : false;
      this.invalid.expat_direction =
        this.newExpat.expat_direction.trim().length == 0 ? true : false;
      this.invalid.expat_destination =
        this.newExpat.expat_destination.trim().length == 0 ? true : false;
      if (
        !this.invalid.shipper_id &&
        !this.invalid.company_id &&
        !this.invalid.expat_rut &&
        !this.invalid.expat_name &&
        !this.invalid.expat_direction &&
        !this.invalid.expat_destination
      ) {
        this.createExpat();
      }
    },
    createExpat() {
      this.load_creation = true;
      let token = this.getToken();
      this.axios
        .post(`${process.env.VUE_APP_EXPATS}`, this.newExpat, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "Expat Created",
            detail: "The expat has been successfully created.",
            life: 5000,
          });
        })
        .catch((error) => {
          // console.log(error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while creating the expat, please try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.createExpatDialog = false;
          this.newExpat = {
            expat_id: "",
            expat_name: "",
            expat_rut: "",
            expat_direction: "",
            expat_destination: "",
            shipper_id: "",
            company_id: "",
          };
          this.load_creation = false;
          this.getExpats();
        });
    },
    confirmDeleteExpat(expat) {
      this.expat = expat;
      this.deleteExpatDialog = true;
    },
    deleteSelectedExpat() {
      let token = this.getToken();
      this.deleteExpatDialog = false;
      this.expats_data_table_loading = true;
      this.axios
        .delete(`${process.env.VUE_APP_EXPATS}/${this.expat.expat_id}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "Deleted data",
            detail: "The selected data was successfully deleted.",
            life: 5000,
          });
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while removing the expat, please try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.getExpats();
        });
    },
    onRowEditExpatInit(event) {
      this.originalRows[event.index] = { ...this.expats[event.index] };
      this.selected_company_id = event.data.company_id;
      this.selected_shipper_id = event.data.shipper_id;
      // this.expats = [];
      this.canEditAnother = false;
      // this.getExpatsByShipperAndCompany();
      // console.log(event);
      setTimeout(() => {
        this.displayEditButton(false);
      }, 50);
    },
    onRowEditExpatCancel(event) {
      // console.log(this.expats, event.index, this.originalRows[event.index]);
      // this.edit_user_profile = false;
      // Vue.set(this.expats, event.index, this.originalRows[event.index]);
      this.getExpats();
      this.displayEditButton(true);
    },
    onRowEditExpatSave(event) {
      // console.log(event);
      let expat_id = event.data.expat_id;
      let expat_data = event.data;
      this.updateExpat(expat_id, expat_data);
      this.displayEditButton(true);
    },
    displayEditButton(can_display) {
      if (can_display) {
        let edit_buttons = document.querySelectorAll(
          "button.p-row-editor-init.p-link"
        );
        for (let index = 0; index < edit_buttons.length; index++) {
          let element = edit_buttons[index];
          element.style.display = "";
        }
      } else {
        let edit_buttons = document.querySelectorAll(
          "button.p-row-editor-init.p-link"
        );
        for (let index = 0; index < edit_buttons.length; index++) {
          let element = edit_buttons[index];
          element.style.display = "none";
        }
      }
    },
    updateExpat(expat_id, body) {
      let token = this.getToken();
      this.expats_data_table_loading = true;
      this.axios
        .put(`${process.env.VUE_APP_EXPATS}/${expat_id}`, body, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "Updated Expat",
            detail: "The expat has been successfully updated.",
            life: 5000,
          });
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while updating the expat, please try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.getExpats();
        });
    },
  },
  components: {
    DataTable,
    Column,
    Toast,
    InputText,
    Toolbar,
    RadioButton,
    InputNumber,
    Button,
    Dialog,
    Textarea,
    Avatar,
    Tag,
    Dropdown,
    ProgressSpinner,
    Calendar,
    InputSwitch,
    Checkbox,
  },
};
</script>
<style scoped>
.input-full-width {
  width: -webkit-fill-available !important;
}
.button-margin-right {
  margin-right: 2px;
}
.input-search-width {
  width: 150px !important;
}
</style>